import React from 'react';
import { withTranslation } from 'react-i18next';

import Error401image from '../../assets/images/error401.png';

const NoAccess = ({ t }) => {
    return (
        <div className="errorPage">
            <h1>401</h1>
            <h3>{t("Jy het nie toegang tot hierdie bladsy nie.")}</h3>
            <img className="errorImage" alt="Error 404" src={Error401image} />
        </div >
    )
}

export default withTranslation(["translation"])(NoAccess);